import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store'; // Import the store we created
import { projectDatesToMoment } from './utilities';
import LeftPanel from './LeftPanel/LeftPanel';
import RightPanel from './RightPanel';

import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { TYPES } from './reducer';

import './ScheduleInspections.css';



// 1. The pure UI component
export function TopLevelState({ match, setVisible, modalType = false }) {
  const { params: { id } = {} } = match;

  const dispatch = useDispatch(); // Get dispatch function

  useEffect(() => {
    return () => {
      dispatch({ type: TYPES.RESET });
    };
  }, [dispatch]);

  return (
    <div className="flex-row">
      <LeftPanel modalType={modalType} setVisible={setVisible} />
      <div style={{ flex: 10 }}>
        <RightPanel posthooks={[projectDatesToMoment]} single={id} />
      </div>
    </div>
  );
}

// 2. The Redux Wrapper
// This replaces your old 'wrap' function
const ReduxWrappedScheduleInspections = (props) => {
  return (
    <Provider store={store}>
      <TopLevelState {...props} />
    </Provider>
  );
};

export default ReduxWrappedScheduleInspections;